var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-nav__content"},[_c('SidebarPanel',{attrs:{"activeBlock":_vm.activeBlock,"changeActiveBlock":_vm.changeActiveBlock}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }